<template>
  <div class="bttn" @click="open">{{$t('vue2.createuser_button.create_user')}}</div>
</template>

<script>
  import eventbus from '../../../eventbus'
  export default {
    methods: {
      open () {
        eventbus.createUserModal = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CreateUserButton.vue?2afdc0e8